import React, { Component } from 'react'
import { Alert } from 'reactstrap'
import { 
  AddSchoolAdminsModal, DistrictsCard, AddDistrictsModal, 
  SchoolsCard, AddSchoolsModal, AddDistrictAdminsModal, 
  TeachersCard, AddTeachersModal, ClassesCard, AddClassesModal,
  AddStudentsToClassesCard, RegistrationCodeModal, ImportUsersModal,
  ManageRecordModal,
} from './'
import { NewManageUsers } from './NewManageUsers'

/*
ManageEducatorsContainer: 

  <ManageEducators
    isInitializing={this.props.isInitializing}
    isInitializingError={this.props.isInitializingError}
    districts={this.props.districts}
    schools={this.props.schools}
    educators={this.props.educators}
    classes={this.props.classes}
    students={this.props.students}
    user={this.user}
    selection={selection}
    modal={modal}
    openModal={this.openModal}
    closeModal={this.closeModal}
    select={this.select}
    forceDistrictExpanded={this.state.forceDistrictExpanded}
    setForceDistrictExpanded={this.setForceDistrictExpanded}
    filters={this.props.filters}
    districtNameSearch={this.state.districtNameSearch}
    setFilter={this.props.setFilter}
    setSearch={this.setSearch}
    setForceExpanded={this.setForceExpanded}
    forceSchoolExpanded={this.state.forceSchoolExpanded}
    forceTeacherExpanded={this.state.forceTeacherExpanded}
    recordId={recordId}
    deleteRecord={this.deleteRecord}
    isDeleting={this.props.isDeleting}
    isDeletingError={this.props.isDeletingError}
  />

*/

class ManageEducators extends Component {
  constructor(props) {
    super(props)

    this.state = {
      teacherSearchVal: ''
    }

    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(e) {
    this.setState({[e.target.name]: e.target.value})
  }

  render() {
    const { isInitializingError } = this.props

    let permissionSuper, permissionDistrict, permissionSchool, permissionTeacher
    if (this.props.user) {
      permissionSuper = this.props.user.role === 'Super Administrator'
      permissionDistrict = this.props.user.role === 'District Admin' || permissionSuper
      permissionSchool = this.props.user.role === 'School Admin' || permissionDistrict
      permissionTeacher = this.props.user.role === 'Teacher' || permissionSchool
    }

    let componentToRender = <p>Loading...<br /><i className="fa fa-spinner fa-lg fa-spin mt-4"></i></p>

    if (this.props.isInitializing) {
      componentToRender = (
        <p>Loading...<br /><i className="fa fa-spinner fa-lg fa-spin mt-4"></i></p>
      )
    } else if (this.props.user && this.props.districts) {
      componentToRender = []
      if (permissionDistrict) {
        componentToRender.push(
          <DistrictsCard 
            districts={this.props.districts}
            selectedDistrict={this.props.selection.district}
            key='DistrictsCard'
            openModal={this.props.openModal}
            select={this.props.select}
            setForceExpanded={this.props.setForceExpanded}
            forceDistrictExpanded={this.props.forceDistrictExpanded}
            districtNameSearch={this.props.districtNameSearch}
            districtStateFilter={this.props.filters.districtState}
            setFilter={this.props.setFilter}
            setSearch={this.props.setSearch}
            permissionSuper={permissionSuper}
          />
        )
      }

      if (permissionSuper) {
        componentToRender.push(
          <AddDistrictsModal
            isOpen={this.props.modal === 'addDistrict'}
            toggle={this.props.closeModal}    
            key='AddDistrictsModal'  
            select={this.props.select}   
          />
        )
      }
      if (permissionSchool) {
        componentToRender.push(
          <SchoolsCard
            districts={this.props.districts}
            schools={this.props.schools}
            key='SchoolsCard'
            selectedDistrict={this.props.selection.district}
            selectedSchool={this.props.selection.school}
            select={this.props.select}
            openModal={this.props.openModal}
            educators={this.props.educators}
            setForceExpanded={this.props.setForceExpanded}
            forceSchoolExpanded={this.props.forceSchoolExpanded}
            permissionDistrict={permissionDistrict}
          />
        )
      }
      componentToRender.push(
        <AddSchoolsModal
          isOpen={this.props.modal === 'addSchool'}
          toggle={this.props.closeModal}
          key='AddSchoolsModal'
          select={this.props.select}
          selectedDistrict={this.props.selection.district}
        />
      )
      componentToRender.push(
        <AddDistrictAdminsModal
          isOpen={this.props.modal === 'addDistrictAdmin'}
          toggle={this.props.closeModal}
          key='AddDistrictAdminsModal'
          select={this.props.select}
          selectedDistrict={this.props.selection.district}
          districts={this.props.districts}
        />
      )
      componentToRender.push(
        <TeachersCard 
          selectedSchool={this.props.selection.school}
          selectedTeacher={this.props.selection.teacher}
          key='TeachersCard'
          schools={this.props.schools}
          select={this.props.select}
          openModal={this.props.openModal}
          educators={this.props.educators}
          setForceExpanded={this.props.setForceExpanded}
          forceTeacherExpanded={this.props.forceTeacherExpanded}
          handleChange={this.handleChange}
          teacherSearchVal={this.state.teacherSearchVal}
          permissionSchool={permissionSchool}
        />
      )
      componentToRender.push(
        <AddSchoolAdminsModal
          isOpen={this.props.modal === 'addSchoolAdmin'}
          key='AddSchoolAdminsModal'
          toggle={this.props.closeModal}
          select={this.props.select}
          selectedSchool={this.props.selection.school}
          schools={this.props.schools}
          educators={this.props.educators}
        />
      )
      componentToRender.push(
        <AddTeachersModal
          isOpen={this.props.modal === 'addTeacher'}
          key='AddTeachersModal'
          toggle={this.props.closeModal}
          select={this.props.select}
          selectedSchool={this.props.selection.school}
          schools={this.props.schools}
          educators={this.props.educators}
          selectedTeacher={this.props.selection.teacher}
        />
      )
      componentToRender.push(
        <ClassesCard
          selectedTeacher={this.props.selection.teacher}
          selectedClass={this.props.selection.class}
          classes={this.props.classes}
          select={this.props.select}
          openModal={this.props.openModal}
          educators={this.props.educators}
          key='ClassesCard'
        />
      )
      componentToRender.push(
        <AddClassesModal
          isOpen={this.props.modal === 'addClass'}
          key='AddClassModal'
          toggle={this.props.closeModal}
          select={this.props.select}
          educators={this.props.educators}
          selectedTeacher={this.props.selection.teacher}
          classes={this.props.classes}
        />
      )
      componentToRender.push(
        <AddStudentsToClassesCard
          students={this.props.students}
          selectedClass={this.props.selection.class}
          classes={this.props.classes}
          key='AddStudentsToClassesCard'
          schools={this.props.schools}
        />
      )
      if (this.props.schools && this.props.selection.school) {
        componentToRender.push(
          <RegistrationCodeModal
            isOpen={this.props.modal === 'teacherRegistrationCode'}
            key='TeacherRegistrationCodeModal'
            toggle={this.props.closeModal}
            selectedSchool={this.props.selection.school}
            role='teacher'  
          />
        )
        componentToRender.push(
          <ImportUsersModal
            isOpen={this.props.modal === 'importTeachers'}
            key='ImportTeachersModal'
            toggle={this.props.closeModal}
            school={this.props.schools[this.props.selection.school]}
            role='Teachers'
          />
        )
      }
      if (this.props.districts && this.props.schools && this.props.students && this.props.districts && this.props.classes) {
        componentToRender.push(
          <ManageRecordModal
            isOpen={this.props.modal === 'record'}
            key='ManageRecordModal'
            toggle={this.props.closeModal}
            recordId={this.props.recordId}
            educators={this.props.educators}
            schools={this.props.schools}
            students={this.props.students}
            districts={this.props.districts}
            classes={this.props.classes}
            deleteRecord={this.props.deleteRecord}
            isDeleting={this.props.isDeleting}
            isDeletingError={this.props.isDeletingError}
          />
        )
      }
    }
  
    
    
    
    
    
    
    return (
      <div>
        {isInitializingError && <Alert>Error loading. Please check your internet connection and try again.</Alert>}
        <NewManageUsers {...this.props} />
        {/* {componentToRender} */}
      </div>
    )
  }
}

export default ManageEducators


// WEBPACK FOOTER //
// ./src/components/Users/ManageEducators.js